// import { useEffect } from 'react';

// const TopGeCounter = () => {
//   useEffect(() => {
//     const script = document.createElement('script');
//     script.src = 'https://counter.top.ge/counter.js';
//     script.async = true;
//     document.body.appendChild(script);
//   }, []);

//   return (
//     <div id="top-ge-counter-container" data-site-id="117912"></div>
//   );
// };

// export default TopGeCounter;


////////////////////
import React, { useEffect, useRef } from 'react';

const TopGeCounter: React.FC = () => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    // ვქმნით სკრიპტს, რომელიც ჩატვირთავს top.ge-ს მთვლელს
    const script = document.createElement('script');
    script.src = 'https://counter.top.ge/counter.js';
    script.async = true;
    document.body.appendChild(script);

    // ვქმნით მუტაციების დამკვირვებელს, რომელიც მოძებნის target="_blank" ბმულებს და დაამატებს rel="noopener noreferrer" ატრიბუტს
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach((node) => {
            // ვამოწმებთ არის თუ არა ელემენტი და აქვს თუ არა querySelector მეთოდი
            if (node.nodeType === 1 && 'querySelector' in node) {
              // ვეძებთ ბმულებს target="_blank" ატრიბუტით top.ge-დან
              const element = node as Element;
              const links = element.querySelectorAll('a[target="_blank"]');
              links.forEach((link) => {
                const rel = link.getAttribute('rel');
                if (!rel || 
                    (!rel.includes('noopener') && !rel.includes('noreferrer'))) {
                  link.setAttribute('rel', 'noopener noreferrer');
                }
              });
            }
          });
        }
      });
    });

    // ვიწყებთ დაკვირვებას DOM-ის ცვლილებებზე
    if (containerRef.current) {
      observer.observe(containerRef.current, { childList: true, subtree: true });
    }

    // ასევე დავაკვირდეთ მთლიან დოკუმენტს, რადგან top.ge შეიძლება სხვაგანაც ჩაირთოს
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      // გავწმინდოთ
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      observer.disconnect();
    };
  }, []);

  return (
    <div id="top-ge-counter-container" data-site-id="117912" ref={containerRef}></div>
  );
};

export default TopGeCounter;